<template>
  <div id="content" class="sections">
    <Head>
      <!-- Primary Meta Tags -->
      <title>{{ changeMetatagHtml($t("accessories.metaTitle")) }}</title>
      <meta name="title" :content="changeMetatagHtml($t('accessories.metaTitle'))">
      <link rel="canonical" href="https://komatools.com/es/accesorios"/>
      <link rel="alternate" href="https://komatools.com/es/accesorios" hreflang="es"/>
      <link rel="alternate" href="https://komatools.com/en/accessories" hreflang="en"/>
      <link rel="alternate" href="https://komatools.com/fr/accessoires" hreflang="fr"/>
      <link rel="alternate" href="https://komatools.com/es/accesorios" hreflang="x-default"/>

      <meta name="description" :content="changeMetatagHtml($t('accessories.metaDescription'))">

      <!-- Open Graph / Facebook -->
      <meta property="og:type" content="website">
      <meta property="og:url" content="https://komatools.com/">
      <meta property="og:title" :content="changeMetatagHtml($t('accessories.metaTitle'))">
      <meta property="og:description" :content="changeMetatagHtml($t('accessories.metaDescription'))">
      <meta property="og:image" content="https://komatools.com/img/komatoolsSocial.jpg">

      <!-- Twitter -->
      <meta property="twitter:card" content="summary_large_image">
      <meta property="twitter:url" content="https://komatools.com/">
      <meta property="twitter:title" :content="changeMetatagHtml($t('accessories.metaTitle'))">
      <meta property="twitter:description" :content="changeMetatagHtml($t('accessories.metaDescription'))">
      <meta property="twitter:image" content="https://komatools.com/img/komatoolsSocial.jpg">
    </Head>
    <div class="section light paddingBigger">
      <div>
        <div class="banner centered">
          <div class="header">
            <h1 class="title">{{ $t("accessories.title") }}</h1>
            <h2 v-html="$t('accessories.subTitle')" class="subTitle"></h2>
          </div>
        </div>
        <details>
          <summary v-html="$t('accessories.summary.title')"></summary>
          <p v-html="$t('accessories.summary.descriptionParagraph1')"></p>
          <p v-html="$t('accessories.summary.descriptionParagraph2')"></p>
          <p v-html="$t('accessories.summary.descriptionParagraph3')"></p>
          <p v-html="$t('accessories.summary.descriptionParagraph4')"></p>
          <p v-html="$t('accessories.summary.descriptionParagraph5')"></p>
          <p v-html="$t('accessories.summary.descriptionParagraph6')"></p>
        </details>

        <div class="options buttons wrap centered">
          <a class="button accent" v-for="(filter, index) in filtersRef" :key="index">
                        <span
                            @click="filterData(filter)"
                            :class="{ active: filter === activeFilter }"
                        >{{ $t(filter.text) }}</span>
          </a>
        </div>
        <div class="banner centered" v-if="error">
          <p v-html="$t(error)"></p>
        </div>
        <div v-else>
          <ArticlesList :articles="searchedArticles"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getArticles from '../../composables/getArticles'
import GENERIC_VARIABLES from "../../../config";
import ArticlesList from '@/components/ArticlesList.vue'
import {Head} from '@vueuse/head'
import {computed, ref} from 'vue'
import {useRoute} from "vue-router";

// Composition API and external JS
export default {
  name: "Accessories",
  components: {ArticlesList, Head},
  setup() {
    const route = useRoute();

    const subcategories = [
      'ELK12CC000010',
      'ELK12CC000021',
      'ELK12CC000022',
      'ELK12CC000024',
      'ELK12CC000025',
      'ELK12CC000026',
      'ELK12CC000034',
      'ELK12CC000036',
      'ELK12CC000038',
      'ELK12CC000046',
      'ELK12CC000048',
      'ELK12CC000053',
      'ELK12CC000054',
      'ELK04A1',
      'ELK04A10',
      'ELK33A01',
      'ELK33A05',
      'ELK33A09'
    ]

    const filterMap = {
      all: 0,
      flashlights: 1,
      drill: 2,
      spareParts: 3,
      otherAccessories: 4
    }

    const filtersRef = ref([
      {text: 'filtersArticles.all.text', code: []},
      {text: 'filtersArticles.flashlights.text', code: ['ELK04A1', 'ELK04A10']},
      {text: 'filtersArticles.drill.text', code: ['ELK12CC000010']},
      {text: 'filtersArticles.spareParts.text', code: ['ELK33A01', 'ELK33A05', 'ELK33A09']},
      {
        text: 'filtersArticles.otherAccessories.text', code: ['ELK12CC000021', 'ELK12CC000022', 'ELK12CC000024',
          'ELK12CC000025', 'ELK12CC000026', 'ELK12CC000034', 'ELK12CC000036', 'ELK12CC000038', 'ELK12CC000046',
          'ELK12CC000048', 'ELK12CC000053', 'ELK12CC000054']
      }
    ])

    const activeFilter = ref(filtersRef.value[0]);

    const filterFromRoute = filterMap[route.query.filter];
    if (filterFromRoute) {
      activeFilter.value = filtersRef.value[filterFromRoute];
    }

    const {articles, error, load} = getArticles(GENERIC_VARIABLES.PRODUCT_BRAND, subcategories)

    load()

    /**
     * This is a function to remove the special character | from javascript
     * More information: https://stackoverflow.com/questions/5796718/html-entity-decode
     */
    const changeMetatagHtml = (html) => {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    }

    const searchedArticles = computed(() => {
      const activeCodes = Array.isArray(activeFilter.value?.code) ? activeFilter.value.code : [];

      if (activeCodes.length === 0) {
        return articles.value;
      }

      return articles.value.filter((article) =>
          activeCodes.includes(article.subcategoryCode)
      );
    });

    const filterData = (filter) => {
      activeFilter.value = filter;
    }

    return {
      searchedArticles,
      filtersRef,
      activeFilter,
      error,
      GENERIC_VARIABLES,
      subcategories,
      changeMetatagHtml,
      filterData
    }
  }
}
</script>
